export { default } from './no-data';
